import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.auth.token;
export const authTokenSelector = (state: RootState) => getState(state).authToken;
export const refreshTokenSelector = (state: RootState) => getState(state).refreshToken;
